module.exports = __webpack_public_path__ + "img/why-icon-active-4.d1ac5552.svg";